import { render, staticRenderFns } from "./MilestoneModal.vue?vue&type=template&id=0ad5ec7d&scoped=true"
import script from "./MilestoneModal.vue?vue&type=script&lang=js"
export * from "./MilestoneModal.vue?vue&type=script&lang=js"
import style0 from "./MilestoneModal.vue?vue&type=style&index=0&id=0ad5ec7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad5ec7d",
  null
  
)

export default component.exports